import { type ObjectValuesUnionType } from '../utils/typing';

export const FlashMessageTypes = Object.freeze({
  DISMISS_AUTO: 'DISMISS:AUTO',
  DISMISS_MANUAL: 'DISMISS:MANUAL',
});
export type FlashMessageType = ObjectValuesUnionType<typeof FlashMessageTypes>;

export const FlashMessageSeverities = Object.freeze({
  NOTICE: 'NOTICE',
  WARNING: 'WARNING',
  ERROR: 'ERROR',
});
export type FlashMessageSeverity = ObjectValuesUnionType<typeof FlashMessageSeverities>;

export const FlashMessageScopes = Object.freeze({
  BASKET: 'BASKET',
  QR: 'QR',
  MP: 'MONOPOLY',
  BOOM: 'BOOM',
});
export type FlashMessageScope = ObjectValuesUnionType<typeof FlashMessageScopes>;
